import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './style.js';
import { withStyles } from '@material-ui/core/styles';
import { Drawer, AppBar, Toolbar, Hidden, Divider } from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import InfoSection from './Sections/Info';
import ProductTab from './Sections/ProductTab';
import MUTypography from '../../ui/MUTypography';
import MUIconButton from '../../ui/MUIconButton';
import { docsInfoSidebarConfig } from '../../../redux/constants/docsInfoContentTypes.js';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      expandedSections: {}
    };
  }

  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  };

  toggleSection = (key, forceExpand = false) => {
    this.setState(prevState => {
      const newExpanded = { ...prevState.expandedSections };

      // InfoSection ana başlığı için toggle davranışı
      if (key === 'API Overview') {
        // Eğer zaten açıksa kapat
        if (prevState.expandedSections[key]) {
          newExpanded[key] = false;
        } else {
          // Diğer tüm başlıkları kapat, sadece bunu aç
          Object.keys(newExpanded).forEach(k => { newExpanded[k] = false; });
          newExpanded[key] = true;
        }
        return { expandedSections: newExpanded };
      }

      // Alt başlıklar için toggle davranışı
      const parentTitle = Object.keys(prevState.expandedSections).find(k => {
        return (
          prevState.expandedSections[k] &&
          docsInfoSidebarConfig.some(section => {
            if (section.title !== k) return false;
            if (!section.items) return false;
            return section.items.some(item => {
              if (item.component === key) return true;
              if (item.subItems) {
                return item.subItems.some(sub => sub.component === key);
              }
              return false;
            });
          })
        );
      });

      // Alt başlık zaten açıksa kapat
      if (parentTitle && prevState.expandedSections[key]) {
        newExpanded[key] = false;
        return { expandedSections: newExpanded };
      }

      // Diğer tüm başlıkları kapat, sadece tıklananı aç
      Object.keys(newExpanded).forEach(k => { newExpanded[k] = false; });
      newExpanded[key] = true;
      if (parentTitle) newExpanded[parentTitle] = true;
      return { expandedSections: newExpanded };
    });
  };

  filterByType(type, filterType) {
    if (filterType === "API") {
      return type === null || type === filterType;
    } else if (filterType === 'SERVICE') {
      return type === filterType;
    }
    return false;
  }

  renderSidebarComponents() {
    const baasList = this.props.combinedProductAndServices.filter(item =>
      this.filterByType(item.type, "SERVICE")
    );
    const apiList = this.props.combinedProductAndServices.filter(item =>
      this.filterByType(item.type, "API")
    );

    return (
      <div>
        <InfoSection
          {...this.props}
          expandedSections={this.state.expandedSections}
          toggleSection={this.toggleSection}
        />
        <Divider />
        <ProductTab
          {...this.props}
          id="1"
          name="API"
          list={apiList}
          expandedSections={this.state.expandedSections}
          toggleSection={this.toggleSection}
        />
        <Divider />
        <ProductTab
          {...this.props}
          id="2"
          name="BAAS"
          list={baasList}
          expandedSections={this.state.expandedSections}
          toggleSection={this.toggleSection}
        />
      </div>
    );
  }

  render() {
    const { classes, theme } = this.props;
    const { mobileOpen } = this.state;

    return (
      <div className={classes.sideBar}>
        <Hidden mdUp>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <MUIconButton
                color="inherit"
                ariaLabel="open drawer"
                onClick={this.handleDrawerToggle}
                className={classes.navIconHide}
              >
                <Menu />
              </MUIconButton>
              <MUTypography variant="title" color="inherit" noWrap={true}>
                sss
              </MUTypography>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={this.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper
            }}
            ModalProps={{
              keepMounted: true
            }}
          >
            {this.renderSidebarComponents()}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            variant="permanent"
            open
            classes={{
              paper: classes.drawerPaper
            }}
          >
            {this.renderSidebarComponents()}
          </Drawer>
        </Hidden>
      </div>
    );
  }
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(Sidebar);
